import styled from "styled-components";
import { colours } from "../../styles/colours.constants";
import { satoshi500 } from "../../styles/font.constants";

export const Wrapper = styled.div`
	position: relative;
	width: 100%;
`;

export const Select = styled.select`
	width: 100%;
	border-radius: 0.5rem;
	outline: none;
	appearance: none;
	border-style: solid;
	border-width: 2px;
	border-color: ${colours.greyDark};
	padding: 0.6rem 2rem 0.6rem 0.6rem;
	color: ${colours.black}D9;
	font-size: 1.1rem;
	${satoshi500}
	letter-spacing: 4%;
	background-color: ${colours.white};
	cursor: pointer;

	&:disabled {
		cursor: not-allowed;
		opacity: 0.5;
	}
`;

export const Caret = styled.div`
	position: absolute;
	top: 50%;
	right: 0.8rem;
	transform: translateY(-50%);
	pointer-events: none;
	display: flex;
`;
